<div class="breadcrumb">
    <div class="container">
        <a routerLink="/">Home</a> > Login
    </div>
</div>

<div class="container">
    <h1>{{ 'Login' | translate}}</h1>
    <p>{{ 'LoginText' | translate}}</p>

    <a (click)="login()" class="button">{{ 'LoginButton' | translate }}</a>
</div>

